import InputMask from "@mona-health/react-input-mask";
import classNames from "classnames";
import { ChangeEvent, forwardRef } from "react";
import styles from "../../styles/Form.module.css";

interface InputProps {
  autoComplete?: string;
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
  inError?: boolean;
  mask?: string;
  max?: number;
  maxLength?: number;
  noPlaceholder?: boolean;
  onAutofill?: (value: string) => void;
  onBlur?: () => void;
  onChange: (value: string) => void;
  placeholder?: string;
  required?: boolean;
  requiredLabel?: string;
  type?: string;
  value?: string;
}

const Input = forwardRef(function (
  {
    autoComplete = "",
    autoFocus,
    className = "",
    disabled = false,
    inError,
    mask,
    max,
    maxLength,
    noPlaceholder = false,
    onAutofill,
    onBlur,
    onChange,
    placeholder,
    required,
    requiredPlaceholder = "",
    type = "text",
    value,
  }: InputProps,
  ref,
): JSX.Element {
  let placeholderVal = placeholder;
  if (!placeholderVal && required && !noPlaceholder)
    placeholderVal = requiredPlaceholder;

  // NOTE: If ref prop is passed in we don't use InputMask because it doesn't work with React.forwardRef
  // Probably something that can be fixed but easier to disable for now since ref is only used for Number.

  const inputProps = {
    autoFocus,
    disabled,
    mask: mask || "",
    max: max || undefined,
    maxLength: maxLength || undefined,
    onBlur,
    value: value || "",
    onChange: (e, masked) => onChange(e.target.value),
    onKeyDown: (e) => e.stopPropagation(),
    autoComplete,
    className: classNames(
      styles.input,
      className,
      { [styles.error]: inError, [styles.disabled]: disabled },
      inError ? "placeholder-red-900/50" : "placeholder-gray-500/50",
      "shadow-sm block text-base border-gray-400 rounded-md",
    ),
    placeholder: placeholderVal,
    ref,
    type,
    onInput: (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target == document.activeElement) return;
      if (onAutofill) onAutofill(e.target.value);
    },
  };

  let InputComp = "input";
  if (!ref && type != "number" && mask) {
    InputComp = InputMask;
    // inputProps.maskChar = "";
  }

  return <InputComp {...inputProps} />;
});

export default Input;
